import { useLanguage } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const content = t.marquee.repeat(4);

  return (
    <div className="overflow-hidden border-y border-accent/60 bg-accent py-4" data-testid="marquee-strip">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        <span className="font-display text-xl font-extrabold uppercase tracking-tight text-canvas sm:text-2xl">{content}</span>
        <span className="font-display text-xl font-extrabold uppercase tracking-tight text-canvas sm:text-2xl" aria-hidden="true">{content}</span>
      </div>
    </div>
  );
};
